(function(){
  var regenschauerPath='/products/regenschauer-asfour-crystal-flush-mount-chandelier-8-light-23-inch-low-ceiling-light';

  function removeExtraCrystalNotes(){
    document.querySelectorAll('.glitz-option-note').forEach(function(note){
      if(note.textContent.trim().toLowerCase()==='additional crystal color available'){
        note.remove();
      }
    });
  }

  function fixStoryImage(){
    var image=document.querySelector('.glitz-story-media--crystal img');
    if(!image)return;
    image.src='https://cdn.shopify.com/s/files/1/0632/1674/6692/files/U5111-4509-228-318_1.png?v=1780005478';
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.alt='Asfour crystal basket chandelier detail';
  }

  function syncRegenschauerSpecs(){
    if(window.location.pathname.indexOf(regenschauerPath)===-1)return;
    var root=document.querySelector('[data-product-section]');
    if(!root)return;
    var specs=root.querySelector('.glitz-spec-tabs');
    if(!specs)return;

    specs.querySelectorAll('small').forEach(function(el){el.remove();});
    var values=specs.querySelectorAll('strong');
    if(values[0]){
      values[0].textContent='872 – Pear Shape';
      values[0].classList.add('is-selected','glitz-spec-selected');
    }

    var selectedFinish=root.querySelector('.glitz-option-group .glitz-option-button.is-selected');
    var finish=selectedFinish?selectedFinish.getAttribute('data-option-value'):'Warm Brass';
    if(values[1]){
      values[1].textContent=finish==='Polished Chrome'?'Satin & Clear':'Absinthe & Clear';
      values[1].classList.add('is-selected','glitz-spec-selected');
    }
  }

  function init(){
    removeExtraCrystalNotes();
    fixStoryImage();
    syncRegenschauerSpecs();
    document.addEventListener('click',function(e){
      var btn=e.target.closest&&e.target.closest('.glitz-option-button');
      if(!btn)return;
      window.setTimeout(syncRegenschauerSpecs,0);
    });
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();
